export default __webpack_public_path__ + "static/media/e-merkator-talk-es.ba828ccc.png";